/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
/* eslint-disable @atlaskit/ui-styling-standard/no-styled */
/* eslint-disable  @atlaskit/ui-styling-standard/no-exported-styles */
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { N0, N200, N60A } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
export var AIAnswerSearchBorder = styled.div(function (_ref) {
  var isLoading = _ref.isLoading,
    isStreaming = _ref.isStreaming;
  return {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    borderRadius: "var(--ds-space-050, 4px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: '0',
    boxSizing: 'border-box',
    overflow: 'hidden',
    zIndex: 3,
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 ".concat("var(--ds-space-050, 4px)", " ", "var(--ds-space-100, 8px)", " ", "var(--ds-space-negative-025, -2px)", " ", N60A, ", 0 0 1px ").concat(N60A), ")"),
    '&::before': {
      content: "''",
      width: '1000vw',
      height: '1000vh',
      left: 'calc(-500vw + 50%)',
      top: 'calc(-500vh + 50%)',
      position: 'absolute',
      zIndex: -2,
      borderRadius: "var(--ds-space-050, 4px)",
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
      background: isLoading || isStreaming ? 'conic-gradient( from var(--gradient-angle, 45deg), #BF63F3, #FFA900 25%, #0469FF 67%, #0065FF, #BF63F3)' : "var(--ds-surface-overlay, ".concat(N0, ")"),
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
      animation: isLoading || isStreaming ? 'rotate 3s infinite linear' : 'rotate-end 3s 1 linear',
      filter: 'blur(25px)'
    },
    '&::after': {
      content: "''",
      width: "100% - ".concat("var(--ds-space-050, 4px)"),
      height: "100% - ".concat("var(--ds-space-050, 4px)"),
      inset: '1px',
      position: 'absolute',
      zIndex: -1,
      borderRadius: "var(--ds-space-050, 4px)",
      backgroundColor: "var(--ds-surface-overlay, ".concat(N0, ")")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '@keyframes rotate': {
      from: {
        transform: 'rotate(0deg)'
      },
      to: {
        transform: 'rotate(360deg)'
      }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '@keyframes rotate-end': {
      from: {
        transform: 'rotate(0deg)',
        background: 'conic-gradient( from var(--gradient-angle, 45deg), #BF63F3, #FFA900 25%, #0469FF 67%, #0065FF, #BF63F3)'
      },
      to: {
        transform: 'rotate(360deg)',
        background: 'conic-gradient( from var(--gradient-angle, 45deg), #BF63F3, #FFA900 25%, #0469FF 67%, #0065FF, #BF63F3)'
      }
    }
  };
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerLoadingSkeletonWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  marginTop: "var(--ds-space-200, 16px)",
  gap: "var(--ds-space-100, 8px)",
  width: '100%'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ReadingAidsLoadingPill = styled.div(function (_ref2) {
  var width = _ref2.width,
    height = _ref2.height;
  return {
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: width ? width : '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: height ? height : '16px',
    borderRadius: '8px',
    background: "linear-gradient(to right, ".concat("var(--ds-background-neutral, rgba(240, 241, 244, 1))", ", ", "var(--ds-background-input-pressed, rgba(252, 252, 252, 1))", ")"),
    animation: 'shimmer 1.5s linear infinite alternate',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '@keyframes shimmer': {
      from: {
        background: "linear-gradient(to right, ".concat("var(--ds-background-neutral, rgba(240, 241, 244, 1))", ", ", "var(--ds-background-input-pressed, rgba(252, 252, 252, 1))", ")")
      },
      to: {
        background: "linear-gradient(to right, ".concat("var(--ds-background-neutral, rgba(240, 241, 244, 1))", ", ", "var(--ds-background-input-pressed, rgba(252, 252, 252, 1))", ")")
      }
    }
  };
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var GeneratingContainer = styled.div({
  display: 'flex',
  height: '92px',
  boxSizing: 'border-box',
  padding: "var(--ds-space-300, 24px)".concat(" ", "var(--ds-space-300, 24px)", " 0px ", "var(--ds-space-300, 24px)")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var GeneratingText = styled.div({
  marginLeft: "var(--ds-space-025, 2px)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  color: "var(--ds-text-subtlest, ".concat(N200, ")"),
  font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ToggleButton = styled.div({
  cursor: 'pointer',
  display: 'block'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ButtonIcon = styled.div({
  display: 'block',
  transform: 'rotate(135deg)'
});
export var Blur = styled.div({
  background: "linear-gradient( 180deg, ".concat("var(--ds-UNSAFE-transparent, rgba(255, 255, 255, 0))", " 0%, ", "var(--ds-surface-overlay, ".concat(N0, ")"), " 100% )"),
  bottom: '0',
  display: 'block',
  height: "var(--ds-space-500, 40px)",
  margin: '0 1px',
  position: 'sticky'
});
export var AISourcesWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: "var(--ds-space-100, 8px)",
  padding: "0 ".concat("var(--ds-space-300, 24px)", " 0 ", "var(--ds-space-300, 24px)")
});